import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/settings/areas";
const apiDropDownEndpoint =
	API_BASE_URL_ENV() + "/admin/settings/dropdown/Area?status=1";

export default class extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	getFooterData = () => {
		return http.get(`${apiDropDownEndpoint}&footer=1`);
	};
	getDropDown = (cityIds) => {
		if (!!cityIds) {
			return http.get(`${apiDropDownEndpoint}&city_ids=${cityIds}`);
		}
		return http.get(`${apiDropDownEndpoint}`);
	};
	getAreasDropDown = (country_ids) => {
		return http.get(`${apiDropDownEndpoint}&country_ids=${country_ids}`);
	};

	getAreaDropDown = () => {
		return http.get(apiDropDownEndpoint);
	};
}
